import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import * as Yup from 'yup';
import Modal from '../../../../ui/Modal';

import { useContext } from '../../Context';
import { usePolicyPlanTemplateContext } from '../../../../../contexts/PolicyPlanTemplateContext';

import {
  Form as BaseForm,
  SelectFieldV2,
  SubmitButton,
} from '../../../../../ui/FormElement';

export default function ChooseCreateType({ show, onHide, startCreate }) {
  const { dispatch, actions, state } = useContext();

  const {
    dispatch: dispatchTemplate,
    actions: actionsTemplate,
    state: stateTemplate,
  } = usePolicyPlanTemplateContext();

  const FormSchema = Yup.object().shape({
    template: Yup.number().required('Please, select a Plan'),
  });

  const [loader, setLoader] = useState(false);
  const [loaderCreateNew, setLoaderCreateNew] = useState(false);

  const [formData, setFormData] = useState({
    template: '',
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.isPossibleCreatePlan(values.template, state.enterpriseId, (result) => {
      setLoader(false);
      if (result.possible) {
        actions.prepareTemplate(state.enterpriseId, values, (plan) => {
          onHide();
          startCreate(plan);
        });
      } else {
        swal(
          {
            title: '',
            text: `The company already has a Platform plan in place. 
                  Only one Platform plan can be active at a time.`,
            type: 'error',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: 'OK',
          },
        );
      }
    });
  };

  useEffect(() => {
    actionsTemplate.load(dispatchTemplate);
  }, []);

  return (
    <Modal show={show} onHide={onHide} header="Select a Plan">
      <BaseForm
        enableReinitialize
        validationSchema={FormSchema}
        initialValues={formData}
        onSubmit={onSubmit}
      >
        <>
          <div>
            <SelectFieldV2
              name="template"
              placeholder={
                  stateTemplate.templates == null
                    ? 'Load Plans'
                    : 'Select a Plan'
                }
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 10005 }),
              }}
              menuPortalTarget={document.body}
              isMulti={false}
              options={(stateTemplate.templates || []).map((item) => ({
                label: item.attributes.name,
                value: item.attributes.id,
              }))}
              label={(
                <>
                  <span>Plan</span>
                  <abbr title="required">*</abbr>
                </>
                )}
            />
          </div>
          <div className="mt50 mb30">
            <Row>
              <Col md={8}>
                <a
                  onClick={onHide}
                  className="btn btn-primary btn-outline width-120"
                >
                  Cancel
                </a>
              </Col>
              <Col md={4} className="text-right">
                <SubmitButton
                  title={`${loader ? 'Adding ...' : 'Add'}`}
                  className={`btn width-120 btn-primary submit-button ${
                    loader ? 'not-possible-click' : ''
                  }`}
                />
              </Col>
            </Row>
          </div>
        </>
      </BaseForm>
    </Modal>
  );
}
